import { useEffect } from 'react';

import { useSDK } from '../../../../../app';

export const useCachedMessageField = (key: string, value: string): void => {
	const { formsStore, uiStateStore } = useSDK();

	useEffect(() => {
		formsStore.setCachedValue(key, value);
		return (): void => {
			formsStore.setCachedValue(key, value);
		};
	}, [key, value, formsStore, uiStateStore.opened]);
};
